var map = {
	"./AboutContainer": [
		880,
		9
	],
	"./AboutContainer.js": [
		880,
		9
	],
	"./AppointmentContainer": [
		6749,
		9
	],
	"./AppointmentContainer.jsx": [
		6749,
		9
	],
	"./AppointmentDoctor": [
		8073,
		9
	],
	"./AppointmentDoctor.jsx": [
		8073,
		9
	],
	"./Appointments": [
		1371,
		9
	],
	"./Appointments.jsx": [
		1371,
		9
	],
	"./AuthorDetail": [
		3618,
		9
	],
	"./AuthorDetail.jsx": [
		3618,
		9
	],
	"./BlogDetail": [
		1329,
		9
	],
	"./BlogDetail.jsx": [
		1329,
		9
	],
	"./Blogs": [
		4971,
		9
	],
	"./Blogs.jsx": [
		4971,
		9
	],
	"./Branding": [
		5447,
		9,
		5447
	],
	"./Branding.jsx": [
		5447,
		9,
		5447
	],
	"./Captcha/Captcha": [
		5902,
		9
	],
	"./Captcha/Captcha.jsx": [
		5902,
		9
	],
	"./CommingSoon": [
		6825,
		9
	],
	"./CommingSoon.jsx": [
		6825,
		9
	],
	"./Complaints": [
		3813,
		9
	],
	"./Complaints.jsx": [
		3813,
		9
	],
	"./Contact": [
		4394,
		9
	],
	"./Contact.jsx": [
		4394,
		9
	],
	"./DepartmentCarousal/DepartmentCarousal": [
		8276,
		9
	],
	"./DepartmentCarousal/DepartmentCarousal.css": [
		8982,
		9
	],
	"./DepartmentCarousal/DepartmentCarousal.jsx": [
		8276,
		9
	],
	"./DepartmentCarousal/DepartmentCarousalSlider": [
		9415,
		9
	],
	"./DepartmentCarousal/DepartmentCarousalSlider.jsx": [
		9415,
		9
	],
	"./Doctor.css": [
		5421,
		9,
		5421
	],
	"./DoctorFolder/About": [
		3356,
		9
	],
	"./DoctorFolder/About.jsx": [
		3356,
		9
	],
	"./DoctorFolder/DoctorSideNav": [
		7040,
		9
	],
	"./DoctorFolder/DoctorSideNav.jsx": [
		7040,
		9
	],
	"./DoctorFolder/E_health_doctor": [
		5700,
		9
	],
	"./DoctorFolder/E_health_doctor.jsx": [
		5700,
		9
	],
	"./DoctorFolder/HospitalClinic": [
		2207,
		9
	],
	"./DoctorFolder/HospitalClinic.jsx": [
		2207,
		9
	],
	"./DoctorFolder/PatientPortal": [
		4035,
		9
	],
	"./DoctorFolder/PatientPortal.jsx": [
		4035,
		9
	],
	"./DoctorNav": [
		2795,
		9
	],
	"./DoctorNav.jsx": [
		2795,
		9
	],
	"./EHealthContainer": [
		7652,
		9
	],
	"./EHealthContainer.js": [
		7652,
		9
	],
	"./E_health": [
		5240,
		9
	],
	"./E_health.jsx": [
		5240,
		9
	],
	"./Footer": [
		1546,
		9
	],
	"./Footer.jsx": [
		1546,
		9
	],
	"./ForgetPassword": [
		5052,
		9
	],
	"./ForgetPassword.jsx": [
		5052,
		9
	],
	"./FourthMainBanner/FourthMainBanner": [
		7901,
		9
	],
	"./FourthMainBanner/FourthMainBanner.css": [
		5034,
		9
	],
	"./FourthMainBanner/FourthMainBanner.jsx": [
		7901,
		9
	],
	"./Gallery": [
		732,
		9
	],
	"./Gallery.jsx": [
		732,
		9
	],
	"./Header": [
		4558,
		9
	],
	"./Header.jsx": [
		4558,
		9
	],
	"./Home": [
		1041,
		9
	],
	"./Home.jsx": [
		1041,
		9
	],
	"./HomeBlogs": [
		5858,
		9
	],
	"./HomeBlogs.jsx": [
		5858,
		9
	],
	"./HomeFacilities": [
		4449,
		9
	],
	"./HomeFacilities.jsx": [
		4449,
		9
	],
	"./HomeNews": [
		5100,
		9
	],
	"./HomeNews.jsx": [
		5100,
		9
	],
	"./HospitalFolder/About": [
		7829,
		9
	],
	"./HospitalFolder/About.jsx": [
		7829,
		9
	],
	"./HospitalFolder/CareerDetail": [
		4197,
		9
	],
	"./HospitalFolder/CareerDetail.jsx": [
		4197,
		9
	],
	"./HospitalFolder/Careers": [
		8334,
		9
	],
	"./HospitalFolder/Careers.jsx": [
		8334,
		9
	],
	"./HospitalFolder/DoctorDetails": [
		6860,
		9
	],
	"./HospitalFolder/DoctorDetails.jsx": [
		6860,
		9
	],
	"./HospitalFolder/Doctors": [
		3349,
		9
	],
	"./HospitalFolder/Doctors.jsx": [
		3349,
		9
	],
	"./HospitalFolder/DropCV": [
		64,
		9
	],
	"./HospitalFolder/DropCV.jsx": [
		64,
		9
	],
	"./HospitalFolder/Facilities": [
		67,
		9
	],
	"./HospitalFolder/Facilities.jsx": [
		67,
		9
	],
	"./HospitalFolder/HospitalSideNav": [
		1107,
		9
	],
	"./HospitalFolder/HospitalSideNav.jsx": [
		1107,
		9
	],
	"./HospitalLogin/Appointment": [
		3657,
		9,
		3657
	],
	"./HospitalLogin/Appointment.jsx": [
		3657,
		9,
		3657
	],
	"./HospitalLogin/EHealthAppointment": [
		9372,
		9
	],
	"./HospitalLogin/EHealthAppointment.jsx": [
		9372,
		9
	],
	"./HospitalNav": [
		9348,
		9
	],
	"./HospitalNav.jsx": [
		9348,
		9
	],
	"./Login": [
		7685,
		9
	],
	"./Login.jsx": [
		7685,
		9
	],
	"./LoginDashboard": [
		8281,
		9
	],
	"./LoginDashboard.jsx": [
		8281,
		9
	],
	"./MainBanner/MainBanner": [
		5960,
		9
	],
	"./MainBanner/MainBanner.css": [
		3641,
		9
	],
	"./MainBanner/MainBanner.js": [
		5960,
		9
	],
	"./Modal/ForgotPasswordModal": [
		6537,
		9,
		6537
	],
	"./Modal/ForgotPasswordModal.jsx": [
		6537,
		9,
		6537
	],
	"./Navbar/navbar": [
		2776,
		9,
		698,
		2776
	],
	"./Navbar/navbar.css": [
		4671,
		9,
		4671
	],
	"./Navbar/navbar.jsx": [
		2776,
		9,
		698,
		2776
	],
	"./News": [
		7038,
		9
	],
	"./News.jsx": [
		7038,
		9
	],
	"./NewsDetail": [
		7977,
		9
	],
	"./NewsDetail.jsx": [
		7977,
		9
	],
	"./ReviewSlider/ReviewSlider": [
		6631,
		9
	],
	"./ReviewSlider/ReviewSlider.css": [
		7210,
		9,
		7210
	],
	"./ReviewSlider/ReviewSlider.jsx": [
		6631,
		9
	],
	"./Reviews": [
		6585,
		9
	],
	"./Reviews.jsx": [
		6585,
		9
	],
	"./SecondMainBanner/SecondMainBanner": [
		7192,
		9
	],
	"./SecondMainBanner/SecondMainBanner.css": [
		1290,
		9
	],
	"./SecondMainBanner/SecondMainBanner.js": [
		7192,
		9
	],
	"./Services": [
		5208,
		9
	],
	"./Services.jsx": [
		5208,
		9
	],
	"./ServicesList": [
		5599,
		9
	],
	"./ServicesList.jsx": [
		5599,
		9
	],
	"./Signup": [
		9438,
		9
	],
	"./Signup.jsx": [
		9438,
		9
	],
	"./Spinner": [
		2919,
		9
	],
	"./Spinner.jsx": [
		2919,
		9
	],
	"./Theme1DashboardComponents/Appointment": [
		8125,
		9
	],
	"./Theme1DashboardComponents/Appointment.jsx": [
		8125,
		9
	],
	"./Theme1DashboardComponents/BloodGlucoseList": [
		8304,
		9
	],
	"./Theme1DashboardComponents/BloodGlucoseList.jsx": [
		8304,
		9
	],
	"./Theme1DashboardComponents/BloodPressureList": [
		3960,
		9
	],
	"./Theme1DashboardComponents/BloodPressureList.jsx": [
		3960,
		9
	],
	"./Theme1DashboardComponents/Calculator": [
		2139,
		9
	],
	"./Theme1DashboardComponents/Calculator.jsx": [
		2139,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/Bmi": [
		3593,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/Bmi.jsx": [
		3593,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/BodyWeightCal": [
		9982,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/BodyWeightCal.jsx": [
		9982,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/Bodyfat": [
		8143,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/Bodyfat.jsx": [
		8143,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/CalculatorTabs": [
		4388,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/CalculatorTabs.jsx": [
		4388,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/ChildernHeightPredictor": [
		4987,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/ChildernHeightPredictor.jsx": [
		4987,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/Edd": [
		4603,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/Edd.jsx": [
		4603,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/HeightCounter": [
		867,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/HeightCounter.jsx": [
		867,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/WeightConverter": [
		423,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/WeightConverter.jsx": [
		423,
		9
	],
	"./Theme1DashboardComponents/CalculatorTabs/calculators": [
		3805,
		7,
		3805
	],
	"./Theme1DashboardComponents/CalculatorTabs/calculators.js": [
		3805,
		7,
		3805
	],
	"./Theme1DashboardComponents/ComparativeNutrients": [
		9603,
		9
	],
	"./Theme1DashboardComponents/ComparativeNutrients.jsx": [
		9603,
		9
	],
	"./Theme1DashboardComponents/Dashboard": [
		1733,
		9
	],
	"./Theme1DashboardComponents/Dashboard.jsx": [
		1733,
		9
	],
	"./Theme1DashboardComponents/DryFruits": [
		2045,
		9,
		2045
	],
	"./Theme1DashboardComponents/DryFruits.jsx": [
		2045,
		9,
		2045
	],
	"./Theme1DashboardComponents/EAppointment": [
		70,
		9
	],
	"./Theme1DashboardComponents/EAppointment.jsx": [
		70,
		9
	],
	"./Theme1DashboardComponents/FruitFilter": [
		2617,
		9
	],
	"./Theme1DashboardComponents/FruitFilter.jsx": [
		2617,
		9
	],
	"./Theme1DashboardComponents/Fruits": [
		8080,
		9
	],
	"./Theme1DashboardComponents/Fruits.jsx": [
		8080,
		9
	],
	"./Theme1DashboardComponents/FruitsDetail": [
		9568,
		9
	],
	"./Theme1DashboardComponents/FruitsDetail.jsx": [
		9568,
		9
	],
	"./Theme1DashboardComponents/FruitsList": [
		3845,
		9
	],
	"./Theme1DashboardComponents/FruitsList.jsx": [
		3845,
		9
	],
	"./Theme1DashboardComponents/Investigation": [
		5989,
		9
	],
	"./Theme1DashboardComponents/Investigation.jsx": [
		5989,
		9
	],
	"./Theme1DashboardComponents/Miscellaneous": [
		8027,
		9,
		8027
	],
	"./Theme1DashboardComponents/Miscellaneous.jsx": [
		8027,
		9,
		8027
	],
	"./Theme1DashboardComponents/Prescripition": [
		7679,
		9
	],
	"./Theme1DashboardComponents/Prescripition.jsx": [
		7679,
		9
	],
	"./Theme1DashboardComponents/PrescripitionTabs/PrescripitionTabs": [
		3689,
		9,
		560,
		3689
	],
	"./Theme1DashboardComponents/PrescripitionTabs/PrescripitionTabs.css": [
		1126,
		9,
		560,
		1126
	],
	"./Theme1DashboardComponents/PrescripitionTabs/PrescripitionTabs.jsx": [
		3689,
		9,
		560,
		3689
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodGlucose": [
		109,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodGlucose.jsx": [
		109,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodGlucoseChart": [
		3518,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodGlucoseChart.js": [
		3518,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodPressure": [
		1581,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodPressure.jsx": [
		1581,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodPressureChart": [
		183,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/BloodPressureChart.js": [
		183,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/FavoritesTabs/DietItems": [
		1674,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/FavoritesTabs/DietItems.jsx": [
		1674,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/FavoritesTabs/FavoritesTabs": [
		7930,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/FavoritesTabs/FavoritesTabs.jsx": [
		7930,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/FavoritesTabs/TipsTricks": [
		9567,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/FavoritesTabs/TipsTricks.jsx": [
		9567,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/ProfileTabs": [
		5277,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/ProfileTabs.jsx": [
		5277,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/BasicAppointment": [
		2763,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/BasicAppointment.jsx": [
		2763,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/EAppointment": [
		2393,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/EAppointment.jsx": [
		2393,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/RecentItems": [
		968,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/RecentItems.jsx": [
		968,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/RecentTabs": [
		912,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/RecentTabs.jsx": [
		912,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/RecentTotkey": [
		7169,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/RecentTabs/RecentTotkey.jsx": [
		7169,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/UpdateAccount": [
		3249,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/UpdateAccount.jsx": [
		3249,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/UpdateProfile": [
		3301,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/UpdateProfile.jsx": [
		3301,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/WeightManageChart": [
		2745,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/WeightManageChart.js": [
		2745,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/WeightManagment": [
		7485,
		9
	],
	"./Theme1DashboardComponents/ProfileTabs/WeightManagment.jsx": [
		7485,
		9
	],
	"./Theme1DashboardComponents/Pulses": [
		615,
		9,
		615
	],
	"./Theme1DashboardComponents/Pulses.jsx": [
		615,
		9,
		615
	],
	"./Theme1DashboardComponents/RegMembers": [
		2082,
		9
	],
	"./Theme1DashboardComponents/RegMembers.jsx": [
		2082,
		9
	],
	"./Theme1DashboardComponents/Totkey": [
		107,
		9
	],
	"./Theme1DashboardComponents/Totkey.js": [
		107,
		9
	],
	"./Theme1DashboardComponents/TotkeyDetail": [
		9384,
		9
	],
	"./Theme1DashboardComponents/TotkeyDetail.jsx": [
		9384,
		9
	],
	"./Theme1DashboardComponents/Vegetable": [
		3946,
		9,
		3946
	],
	"./Theme1DashboardComponents/Vegetable.jsx": [
		3946,
		9,
		3946
	],
	"./Theme1DashboardComponents/WeightManagmentList": [
		3790,
		9
	],
	"./Theme1DashboardComponents/WeightManagmentList.jsx": [
		3790,
		9
	],
	"./Theme1DashboardTabs/DashboardTabs": [
		1279,
		9
	],
	"./Theme1DashboardTabs/DashboardTabs.css": [
		6284,
		9,
		6284
	],
	"./Theme1DashboardTabs/DashboardTabs.js": [
		1279,
		9
	],
	"./ThirdMainSlider/ThirdMainSlider": [
		8733,
		9
	],
	"./ThirdMainSlider/ThirdMainSlider.css": [
		9739,
		9
	],
	"./ThirdMainSlider/ThirdMainSlider.js": [
		8733,
		9
	],
	"./black.css": [
		1796,
		9,
		1796
	],
	"./blue.css": [
		9171,
		9,
		9171
	],
	"./gold.css": [
		2582,
		9,
		2582
	],
	"./red.css": [
		5862,
		9,
		5862
	],
	"./select": [
		1570,
		7,
		1570
	],
	"./select.jsx": [
		1570,
		7,
		1570
	],
	"./themeassets/css/plugins/animate.css": [
		9530,
		9
	],
	"./themeassets/css/plugins/bootstrap.min.css": [
		7159,
		9
	],
	"./themeassets/css/plugins/fontawesome.min.css": [
		6971,
		9
	],
	"./themeassets/css/plugins/jquery-ui.css": [
		6529,
		9
	],
	"./themeassets/css/plugins/jquery.timepicker.min.css": [
		5380,
		9
	],
	"./themeassets/css/plugins/lightgallery.min.css": [
		4330,
		9
	],
	"./themeassets/css/plugins/odometer.css": [
		9701,
		9
	],
	"./themeassets/css/plugins/select2.min.css": [
		6777,
		9
	],
	"./themeassets/css/plugins/slick.css": [
		5753,
		9
	],
	"./themeassets/css/style.css": [
		3973,
		9,
		3973
	],
	"./themeassets/fonts/fa-brands-400.ttf": [
		6728,
		1,
		6728
	],
	"./themeassets/fonts/fa-brands-400.woff2": [
		3437,
		1,
		3437
	],
	"./themeassets/fonts/fa-regular-400.ttf": [
		5829,
		1,
		5829
	],
	"./themeassets/fonts/fa-regular-400.woff2": [
		2586,
		1,
		2586
	],
	"./themeassets/fonts/fa-solid-900.ttf": [
		4899,
		1,
		4899
	],
	"./themeassets/fonts/fa-solid-900.woff2": [
		2130,
		1,
		2130
	],
	"./themeassets/fonts/fa-v4compatibility.ttf": [
		7798,
		1,
		7798
	],
	"./themeassets/fonts/fa-v4compatibility.woff2": [
		3406,
		1,
		3406
	],
	"./themeassets/fonts/lgd41d.eot": [
		4344,
		1,
		4344
	],
	"./themeassets/fonts/lgd641.eot": [
		7096,
		1,
		7096
	],
	"./themeassets/fonts/lgd641.svg": [
		4683,
		1,
		4683
	],
	"./themeassets/fonts/lgd641.ttf": [
		2678,
		1,
		2678
	],
	"./themeassets/fonts/lgd641.woff": [
		7849,
		1,
		7849
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1936;
module.exports = webpackAsyncContext;